import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/Ecommerce_Chatbot_Poster_Webchat_2_Poster.png")